<template>
  <div class="panel">
    <div class="content">
      <div class="title-container">
        <div v-if="!editName" class="editable title" @click="editName = true">
          {{ sectionName }}<Pen class="edit-icon" />
        </div>
        <div v-else class="title-edit">
          <FireInput
            ref="sectionName-field"
            class="text-input"
            :value="sectionName"
            @change="value => (sectionName = value)"
          />
          <div class="cancel" @click.stop="undoSectionName">
            <Cross class="icon" />
          </div>
          <div class="validate" @click.stop="changeSectionName">
            <Check class="icon" />
          </div>
        </div>
        <InfoBubbleIcon class="icon info-bubble-anchor" @click="togglePopup" />
        <HelpBubble :content="sectionsInfos" :visible="showPopup" @on-click="closePopup" />
      </div>
      <div class="divider"></div>
      <div class="check">
        <input
          id="newPage"
          type="checkbox"
          :checked="item.content.startNewPage"
          @change="value => itemChanged(value.target.checked, 'startNewPage')"
        />
        <label for="newPage">{{ $t('editor.newPage') }}</label>
      </div>
      <div class="section">
        <div class="items">
          <div class="item">
            <div class="text">{{ $t('editor.formations.date') }}</div>
            <div class="field" @click="sectionSelected('date')">
              <FireInput
                ref="date-field"
                class="text-input"
                :value="item.content.date"
                @change="value => itemChanged(value, 'date')"
              />
            </div>
          </div>
          <div class="item">
            <div class="text">{{ $t('editor.formations.name') }}</div>
            <div class="field" @click="sectionSelected('title')">
              <FireInput
                ref="title-field"
                class="text-input"
                :value="item.content.title"
                @change="value => itemChanged(value, 'title')"
              />
            </div>
          </div>

          <div class="item nopadding">
            <div class="text relative-container">
              {{ $t('editor.formations.values') }}

              <MagicWand
                class="magic-wand-container"
                :initial-text="item.content.info"
                :prompt-context="getMagicWandContext()"
                @insert="
                  value => {
                    itemChanged(value, 'info');
                    updateFields();
                  }
                "
              />
            </div>

            <div class="field" @click="sectionSelected('info')">
              <FireArea
                ref="info-field"
                :template-div-container="'info'"
                :value="item.content.info"
                @change="value => itemChanged(value, 'info')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="secondary-button inverted" @click.stop="removeItem">
        <BinIcon class="icon" />{{ $t('editor.formations.delete') }}
      </div>
      <div class="secondary-button mt" @click="addItem"><AddIcon class="icon" />{{ $t('editor.formations.add') }}</div>
    </div>
    <div ref="resize-handle" class="resize">
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
  </div>
</template>

<script>
import PanelMixin from './mixins/PanelMixin';
import FireInput from '@/components/inputs/FireInput';
import FireArea from '@/components/inputs/FireArea';
import AddIcon from '@/assets/listing/add.svg';
import BinIcon from '@/assets/listing/bin.svg';
import HelpBubble from '@/components/HelpBubble.vue';
import InfoBubbleIcon from '@/assets/icons/infobulle.svg';
import sectionInfosData from '@/helpers/SectionHelp.js';
import InfoBubbleMixin from '@/components/panels/mixins/InfoBubbleMixin.vue';
import MagicWand from '@/components/magic-wand/MagicWand.vue';

export default {
  name: 'FormationPanel',
  components: {
    InfoBubbleIcon,
    HelpBubble,
    FireInput,
    FireArea,
    AddIcon,
    BinIcon,
    MagicWand,
  },
  mixins: [PanelMixin, InfoBubbleMixin],
  props: {
    currentSection: {
      type: String,
      default: '',
    },
  },
  emits: ['sectionSelected', 'deleteItem', 'addItem'],
  data() {
    return {
      sectionId: 'formations',
    };
  },
  computed: {
    sectionsInfos() {
      return sectionInfosData[this.sectionId];
    },
  },
  watch: {
    currentSection(section) {
      if (section && this.$refs[section + '-field']) {
        this.$refs[section + '-field'].focus();
      }
    },
  },
  mounted() {
    this.checkIfMustOpenPopup(this.sectionId);

    if (this.currentSection && this.$refs[this.currentSection + '-field']) {
      this.$refs[this.currentSection + '-field'].focus();
    }
  },
  methods: {
    sectionSelected(section) {
      this.$emit('sectionSelected', section);
    },
    removeItem() {
      this.$emit('deleteItem', this.item);
    },
    addItem() {
      this.$emit('addItem', this.item.type);
    },
    updateFields() {
      this.dontSendNext = true;
      this.$refs['date-field'].input = this.item.content.date;
      this.dontSendNext = true;
      this.$refs['title-field'].input = this.item.content.title;
      this.dontSendNext = true;
      this.$refs['info-field'].input = this.item.content.info;
    },

    getMagicWandContext() {
      return JSON.stringify({
        candidate: this.resume.candidate,
        item: this.item,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/inspector.scss';
@use '@/styles/colors.scss';

.check {
  display: flex;
  align-items: center;
  margin: 1rem 0;
  label {
    margin-left: 4px;
    user-select: none;
    display: block;
    @extend .uppercase-first;
    color: colors.$dark-grey-color;
    cursor: pointer;
  }
}

.relative-container {
  position: relative;
}

.magic-wand-container {
  position: absolute;
  top: 0;
  right: 0;
}

.title-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    cursor: pointer;
    height: 24px;
    margin-right: 8px;
    transition-duration: 0.1s;

    &:hover {
      scale: 1.1;
    }

    &:active {
      scale: 0.9;
    }
  }
}
</style>
